document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('hc-product')) return;

  const qtyWrapper = document.querySelector('.hc-quantity');
  if (!qtyWrapper) return;

  const qtyInput = qtyWrapper.querySelector('#hc-quantity');
  const externalInput = document.querySelector('.hc-input-default');
  if (!qtyInput) return;

  const qtyDisplay = document.createElement('span');
  qtyDisplay.textContent = qtyInput.value;
  qtyWrapper.insertBefore(qtyDisplay, qtyWrapper.querySelector('.qtyplus'));

  function updateValue(newVal) {
    qtyInput.value = newVal;
    qtyDisplay.textContent = newVal;
    if (externalInput) {
      externalInput.value = newVal;
    }
  }

  qtyWrapper.addEventListener('click', (e) => {
    if (e.target.classList.contains('qtyplus')) {
      updateValue(parseInt(qtyInput.value, 10) + 1);
    }
    if (e.target.classList.contains('qtyminus')) {
      updateValue(Math.max(1, parseInt(qtyInput.value, 10) - 1));
    }
  });

  qtyInput.addEventListener('input', () => {
    updateValue(Math.max(1, parseInt(qtyInput.value, 10) || 1));
  });
});


$(document).ready(function () {
  $(".hc-slideshow").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    focusOnSelect: true,
    prevArrow: '<div class="hc-arrow-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
    nextArrow: '<div class="hc-arrow-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'
  });
});

